export default __webpack_public_path__ + "static/media/whitepaper4.a74e2f33.png";